import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Table } from 'react-bootstrap';
import AccountSearchCard from '../components/search/AccountSearchCard';
import PremiseSearchCard from '../components/search/PremiseSearchCard';
import { formatAddress } from '../utils/formatters';
import LoadingSpinner from '../components/common/LoadingSpinner';

const SearchPage = () => {
  const navigate = useNavigate();

  // Premise search results
  const [premiseResults, setPremiseResults] = useState([]);
  const [showResults, setShowResults] = useState(false);

  // Handle selecting a premise result
  const handleSelectPremise = (acctId) => {
    navigate(`/customer/${acctId}`);
  };

  return (
    <Container id="search-page">
      <Row>
          {/* Account Number Search */}
          <Col lg={6} className="mb-4">
            <AccountSearchCard/>
          </Col>

          {/* Premise Address Search */}
          <Col lg={6} className="mb-4">
            <PremiseSearchCard
              setPremiseResults={setPremiseResults}
              setShowResults={setShowResults}
            />
          </Col>
        </Row>
        <Row>
          <Col>
          {/* Premise Search Results */}
          {showResults && (
            <Card className="shadow mt-4">
              <Card.Header>
                <h5 className="mb-0">Search Results ({premiseResults?.length || 0})</h5>
              </Card.Header>
              <Card.Body className="p-0">
                {(!premiseResults || premiseResults.length === 0) && <div className="text-center m-3 w-100">No results found.</div>}
                {premiseResults?.length > 0 && (
                  <Table striped hover responsive className="mb-0">
                      <>
                        <thead>
                          <tr>
                            <th style={{ width: '120px' }}>Action</th>
                            <th>Customer Name</th>
                            <th>Service Address</th>
                          </tr>
                        </thead>
                        <tbody>
                          {premiseResults?.length > 0 && premiseResults.map((result, index) => (
                            <tr key={index}>
                              <td>
                                <Button
                                  size="sm"
                                  variant="primary"
                                  onClick={() => handleSelectPremise(result.acctId)}
                                >
                                  Details
                                </Button>
                              </td>
                              <td>{result.customerName}</td>
                              <td>{formatAddress({ address: result.premiseAddress, city: result.premiseCity })}</td>
                            </tr>
                          ))}
                        </tbody>
                      </>
                  </Table>
                )}
              </Card.Body>
            </Card>
          )}
          </Col>
        </Row>
    </Container>
  );
};

export default SearchPage;
